// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import CourseContent from '../../components/CourseContent';
import MainLayout from '../../layouts/MainLayout';
import EmptyIcon from '../../assets/images/course-content-empty.svg';
import iltCourseContentsSelector from '../../redux/selectors/iltCourseContentsSelector';
import iltCourseInformationSelector from '../../redux/selectors/iltCourseInformationSelector';
import { useParamsId } from '../../lib/utility';
import LoadingIcon from '../../components/LoadingIcon';
import ErrorPage from '../ErrorPage';
import {
  useIltCourseInformation,
  useFetchIltCourseInformation,
  useFetchIltCourseContents,
  useUpdateProgress,
  useProgress,
  useHasCourse,
  useHasSample,
} from './hooks';
import Button from '../../components/Button';

const S = {
  LoadingContainer: styled.div`
    display: flex;
    margin-top: auto;
    flex-direction: column;
    align-items: center;

    > * + * {
      margin-top: 36px;
    }
  `,
  P: styled.p`
    font-size: 18px;
    line-height: 30px;
    text-align: center;
    color: #313131;
  `,
  Retry: styled.a`
    color: #EF8200;
    cursor: pointer;
    text-decoration-line: underline;
    text-underline-offset: 2px;
  `,
  Img: styled.img`
    width: 220px;
    height: 220px;
  `,
  Button: styled(Button)`
    width: 142px;
    height: 44px;
  `
};

const IltCourseContentPage = ():JSX.Element => {
  const id = useParamsId();
  const isChaptersFetching = useSelector(iltCourseContentsSelector.makeIsFetchingIltCourseContentsData());
  const chapters = useSelector(iltCourseContentsSelector.makeIltCourseContentsDataByIdSelector(id));
  const isFetching = useSelector(iltCourseInformationSelector.makeIsFetchingIltCourse());
  const { name, contactEmail } = useIltCourseInformation(id);
  const errors = useSelector(iltCourseInformationSelector.makeError());
  const progress = useProgress(id);
  const hasCourse = useHasCourse(id);
  const hasSample = useHasSample(id);

  const fetchIltCourseInformation = useFetchIltCourseInformation(id);
  const fetchIltCourseContents = useFetchIltCourseContents(id);
  const updateProgress = useUpdateProgress(id);

  useEffect(() => {
    fetchIltCourseInformation();
    fetchIltCourseContents();
  }, [id])

  if (isFetching || isChaptersFetching) {
    return (
      <MainLayout>
        <S.LoadingContainer>
          <LoadingIcon size={20} />
        </S.LoadingContainer>
      </MainLayout>
    );
  }

  if (errors) {
    console.log({errors})
    return (
      <MainLayout>
        <S.LoadingContainer>
          <ErrorPage />
        </S.LoadingContainer>
      </MainLayout>
    );
  }

  if (!hasCourse) {
    return (
      <MainLayout>
        <S.LoadingContainer>
          <S.Img src={EmptyIcon} alt="empty-icon" />
          <S.P><FormattedMessage id="F022" values={{ br: <br/>, managerEmail: contactEmail || 'training@ecloudvalley.com' }} /></S.P>
          <S.Button as="a" href="/home"><FormattedMessage id="F023" /></S.Button>
        </S.LoadingContainer>
      </MainLayout>
    )
  }

  return (
    <MainLayout>
      <CourseContent
        courseId={id}
        name={name}
        chapters={chapters}
        chaptersIsFetching={isChaptersFetching}
        progress={progress}
        handleUpdateProgress={updateProgress}
      />
    </MainLayout>
  );
}

export { IltCourseContentPage as default }
